import { useEffect, useState } from 'react';
import { Trash2, Loader2, Download, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api, { API_BASE } from '@/lib/api';
import { toast } from 'sonner';
import { getToken } from '@/lib/auth';

export default function AdminApplications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/applications');
      setItems(r.data);
    } catch { toast.error('Erreur'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Supprimer cette candidature ?')) return;
    try {
      await api.delete(`/admin/applications/${id}`);
      setItems(it => it.filter(x => x.id !== id));
      toast.success('Candidature supprimée');
    } catch { toast.error('Erreur'); }
  };

  const downloadCv = async (item) => {
    if (!item.cv_url) return;
    try {
      const res = await fetch(`${API_BASE}${item.cv_url.replace('/api','')}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      if (!res.ok) throw new Error('Erreur');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = item.cv_filename || 'cv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch { toast.error('Impossible de télécharger le CV'); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="h2 text-anthracite-950">Candidatures</h1>
        <p className="text-muted-foreground mt-1">{items.length} candidature{items.length > 1 ? 's' : ''}</p>
      </div>

      {loading ? (
        <div className="py-12 text-center"><Loader2 className="h-6 w-6 animate-spin mx-auto text-brand-700" /></div>
      ) : items.length === 0 ? (
        <div className="card-base p-12 text-center text-muted-foreground">Aucune candidature.</div>
      ) : (
        <div className="space-y-3">
          {items.map(a => (
            <article key={a.id} className="card-base p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-heading font-semibold text-anthracite-950">{a.prenom} {a.nom} <span className="text-xs uppercase tracking-wide ml-2 px-2 py-0.5 rounded bg-brand-50 text-brand-700">{a.poste}</span></p>
                  <p className="text-xs text-muted-foreground mt-1">{new Date(a.created_at).toLocaleString('fr-FR')}</p>
                  <div className="text-sm text-anthracite-700 mt-2">
                    <a href={`mailto:${a.email}`} className="hover:underline text-brand-700">{a.email}</a> • <a href={`tel:${a.telephone}`} className="hover:underline">{a.telephone}</a>
                  </div>
                  {a.message && <p className="mt-2 text-sm text-anthracite-800 whitespace-pre-wrap line-clamp-3">{a.message}</p>}
                  {a.cv_filename && (
                    <div className="mt-2 inline-flex items-center gap-2 text-sm">
                      <FileText className="h-4 w-4 text-brand-700" /> CV : {a.cv_filename}
                    </div>
                  )}
                </div>
                <div className="flex gap-2">
                  {a.cv_url && <Button variant="outline" size="sm" onClick={() => downloadCv(a)}><Download className="h-3.5 w-3.5" /> CV</Button>}
                  <Button variant="outline" size="sm" onClick={() => remove(a.id)} className="text-destructive border-destructive/30 hover:bg-destructive/10"><Trash2 className="h-3.5 w-3.5" /></Button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
